import { combineReducers } from 'redux'
import views from './viewReducers'

const rootReducer = combineReducers({
  views
})

export default rootReducer;